import type { RosterBooking } from '../../../../api/workshops';

import { CheckInFooter } from './CheckInFooter';
import { CheckInHeader } from './CheckInHeader';
import { CheckInProgress } from './CheckInProgress';
import { CheckInRowList } from './CheckInRowList';
import { CheckInSearchInput } from './CheckInSearchInput';

/** The centered dialog card: header, seats progress, search, the row list, and
 *  the footer. */
export function CheckInModalCard({
  fullScreen,
  title,
  checkedInSeats,
  confirmedAttendees,
  query,
  onQueryChange,
  rows,
  pendingId,
  onToggle,
  onOpenStepper,
  onClose,
  returnsTo,
}: {
  fullScreen: boolean;
  title: string;
  checkedInSeats: number;
  confirmedAttendees: number;
  query: string;
  onQueryChange: (v: string) => void;
  rows: RosterBooking[];
  pendingId: string | undefined;
  onToggle: (b: RosterBooking, nextCount: number) => void;
  onOpenStepper: (b: RosterBooking) => void;
  onClose: () => void;
  returnsTo: string;
}) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Check in"
      onClick={(e) => e.stopPropagation()}
      className="nb-card"
      style={{
        // Full-screen sheet on phones; centered 460px card otherwise.
        width: fullScreen ? '100%' : 460,
        maxWidth: '100%',
        height: fullScreen ? '100dvh' : undefined,
        maxHeight: fullScreen ? '100dvh' : '88vh',
        borderRadius: fullScreen ? 0 : undefined,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <CheckInHeader title={title} onClose={onClose} />
      <CheckInProgress checkedInSeats={checkedInSeats} confirmedAttendees={confirmedAttendees} />
      <CheckInSearchInput value={query} onChange={onQueryChange} />
      <CheckInRowList
        rows={rows}
        pendingId={pendingId}
        onToggle={onToggle}
        onOpenStepper={onOpenStepper}
      />
      <CheckInFooter onClose={onClose} returnsTo={returnsTo} />
    </div>
  );
}
